import { motion } from "framer-motion";
import { Boxes, SlidersHorizontal, HeartPulse, Users, ArrowUpRight } from "lucide-react";
import { SERVICES, IMG } from "@/data/menu";
import { Reveal } from "@/components/site/Reveal";

const ICONS = [Boxes, SlidersHorizontal, HeartPulse, Users];

export default function ServicesSection() {
  return (
    <section id="services" data-testid="services-section" className="bg-coffee text-beige py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-brand">What We Do</p>
          <h2 className="mt-3 font-display text-4xl sm:text-6xl font-bold tracking-tight">More than a cafe.</h2>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-5 rounded-[2.5rem] overflow-hidden border border-coffee-soft relative min-h-[320px]">
            <img src={IMG.consult} alt="Nutrition consultation" className="w-full h-full object-cover absolute inset-0" />
            <div className="absolute inset-0 bg-gradient-to-t from-coffee via-coffee/20 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="text-xs uppercase tracking-[0.2em] text-amber-brand font-bold">Sit down with us</p>
              <p className="font-display text-2xl font-bold">Nutrition, personalised.</p>
            </div>
          </Reveal>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={s.title}
                  data-testid={`service-${i}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="group rounded-3xl border border-coffee-soft p-7 hover:bg-coffee-soft/40 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <span className="grid place-items-center w-12 h-12 rounded-full bg-[#8A2231] text-white"><Icon size={22} /></span>
                    <ArrowUpRight className="text-amber-brand opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                  </div>
                  <span className="mt-5 inline-block text-[10px] uppercase tracking-[0.2em] text-amber-brand font-bold">{s.tag}</span>
                  <h3 className="mt-1 font-display text-2xl font-bold">{s.title}</h3>
                  <p className="mt-2 text-beige/70 text-sm leading-relaxed">{s.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
